import { alpha, Box, Button, Chip, styled, Typography } from "@mui/material";

export const BannerCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>(({ theme, isCollapsed }) => ({
  height: "100%",
  backgroundColor: alpha(theme.palette.common.white, 0.1),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
  padding: theme.spacing(1.5),
  display: "flex",
  flexDirection: isCollapsed ? "row" : "column",
  alignItems: "stretch",
  justifyContent: isCollapsed ? "center" : "flex-start",
  overflow: isCollapsed ? "hidden" : undefined,
  gap: theme.spacing(0.5),
}));

export const CardEyebrow = styled(Typography)({
  opacity: 0.7,
  lineHeight: 1.2,
  fontSize: "0.6rem",
});

export const CardVersionName = styled(Typography)({
  fontSize: "0.8rem",
  lineHeight: 1.2,
});

export const CardTotalCost = styled(Typography)({
  fontSize: "1rem",
  lineHeight: 1.2,
});

export const CardBaselineNote = styled(Typography)({
  opacity: 0.7,
  fontSize: "0.7rem",
});

export const CardDeltaRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

export const CardDeltaAmount = styled(Typography)({
  opacity: 0.8,
  fontSize: "0.7rem",
});

export const CardDeltaChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isIncrease",
})<{ isIncrease: boolean }>(({ theme, isIncrease }) => ({
  height: 18,
  fontSize: "0.7rem",
  fontWeight: 700,
  backgroundColor: isIncrease ? theme.palette.error.main : theme.palette.success.main,
  color: theme.palette.common.white,
  "& .MuiChip-icon": {
    color: "inherit",
    fontSize: "0.8rem",
    marginLeft: 4,
  },
  "& .MuiChip-label": {
    padding: "0 4px",
  },
}));

export const OpenScenarioButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  fontSize: "0.75rem",
  lineHeight: 1.2,
  padding: theme.spacing(0.5, 1),
  minWidth: 0,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.85),
  },
  "&.Mui-disabled": {
    color: theme.palette.common.white,
  },
  "& .MuiButton-endIcon": {
    marginLeft: 4,
  },
  "& .MuiButton-endIcon > svg": {
    fontSize: "0.95rem",
  },
}));
